import _ from '@luna/lodash';
import { createSingleton } from '@luna/utils';

import type { Features } from './isFeatureEnabled';

export interface FlagsServicePayload {
    activated: (keyof Features)[];
    deactivated: (keyof Features)[];
}

function parseFlagsServiceResponse(response: FlagsServicePayload): Features {
    const gatekeeperFeatures: Features = {};

    response?.activated?.forEach((key) => {
        _.set(gatekeeperFeatures, `${key}.enabled`, true);
    });
    response?.deactivated?.forEach((key) => {
        _.set(gatekeeperFeatures, `${key}.enabled`, false);
    });

    return gatekeeperFeatures;
}

const { get, set } = createSingleton<Features>({});

export const getFeatureFlagsFromApi = get;

export function fetchFeatureFlags(
    featureFlagsLoader: () => Promise<FlagsServicePayload>,
): Promise<Features> {
    return featureFlagsLoader()
        .then(parseFlagsServiceResponse)
        .then((flags) => {
            set(flags);
            return flags;
        });
}
